import { ReactNode } from 'react'

import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import { ButtonColor } from '@/components/view/atoms/button/Button'

import ConfirmDialog from '@/components/container/modal/dialog/confirm/ConfirmDialog'

interface ConfirmDialogState {
  message: string | ReactNode
  noText: string
  yesText: string
  buttonColor?: ButtonColor
  onClickYes(): Promise<void>
}

const defaultValue = {
  message: '',
  noText: '',
  yesText: '',
  onClickYes: async () => {}
}

export const ConfirmDialogContext = createModalContext<ConfirmDialogState>(defaultValue)

const ConfirmDialogProvider = ({ children }: ChildProps) => {
  const state = useModalState<ConfirmDialogState>(defaultValue)
  return (
    <ConfirmDialogContext.Provider value={state}>
      {children}
      <ConfirmDialog />
    </ConfirmDialogContext.Provider>
  )
}

export default ConfirmDialogProvider
